import _ from 'underscore';
import URI from 'urijs';
import { JsDataRestStore } from '@bingads-webui/js-data-rest';
import { join } from '@bingads-webui/url-util';
import RestfulServiceBase from '@bingads-webui-clientcenter/restful-service';
import type { RestfulServiceOptions } from '@bingads-webui-clientcenter/restful-service';
import { staticResourceConfig } from './static-resource';
import type { JsDataInfo, StaticResourceDefinition } from './types';

/**
 * Create RestfulService with given options, and use to create jsdata objects
 * @param {Object} options - constructor paramaters for '@bingads-webui-clientcenter/restful-service'
 * @param {string} ccRootUrl - url of root CC server
 * @param {Array} resourceNames - array of string jsData resource names like "FeatureAdoptionCoupon" to filter on
 * @return {Object} - jsdata rest service, and jsdata rest store
 */
export function GetJsDataInfo(
  options: RestfulServiceOptions & Record<string, unknown> = {},
  ccRootUrl = '',
  resourceNames: string[] = []
): JsDataInfo {
  const restfulService = new RestfulServiceBase(options);
  const jsDataRestStore = new JsDataRestStore({ restfulService });
  const cleanedCcRootUrl = URI(ccRootUrl).path('').toString();
  // SupportUI API requests should only come from SupportUI
  const emptyUrl = URI('').path('').toString();

  const selectedResources = resourceNames && resourceNames.length > 0
    ? _.pick(staticResourceConfig, resourceNames)
    : staticResourceConfig;

  _.each(
    selectedResources,
    (config: StaticResourceDefinition, name: string) => jsDataRestStore.defineRestResource(name, {
      ...config,
      uriPath: join(config.isSupportUIAPI ? emptyUrl : cleanedCcRootUrl, config.uriPath),
    })
  );

  const jsDataCcRest = jsDataRestStore.definitions;

  return { jsDataCcRest, jsDataRestStore };
}
